import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
// @material-ui/icons
// import Menu from "@material-ui/icons/Menu";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SendIcon from "@material-ui/icons/Send";
import Menu from "@material-ui/core/Menu";
// core components
import headerStyle from "./header-style";
import SearchBox from '../../components/SearchBox';
import { List, ListItem, ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
            sticky: false,
            scroll: 0,
            settingOpen: false
        };
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.headerColorChange = this.headerColorChange.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleSettingMenu = this.handleSettingMenu(this);
    }
    handleScroll() {
        this.setState({ scroll: window.scrollY });
    }
    handleDrawerToggle() {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    }
    handleSettingMenu() {
        this.setState({ settingOpen: !this.state.settingOpen });
    }
    componentDidMount() {
        if (this.props.changeColorOnScroll) {
            window.addEventListener("scroll", this.headerColorChange);
        }
        window.addEventListener('scroll', this.handleScroll);
        this.getPosition();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.history !== this.props.history || prevProps.notHomePage !== this.props.notHomePage)
            this.getPosition();
    }
    getPosition = () => {
        setTimeout(() => {
            const el = document.body.getElementsByTagName("header")[0];
            if (el && (this.props.notHomePage || this.props.loginPage))
                this.setState({ top: el.offsetTop, height: el.offsetHeight }, () => {
                    const { setHeaderHeight } = this.props;
                    if (setHeaderHeight)
                        setHeaderHeight(el.offsetHeight);
                });
            else if (el && !this.props.notHomePage) {
                this.setState({ top: window.scrollY + window.innerHeight - el.offsetHeight, height: el.offsetHeight }, () => {
                    const { setHeaderHeight } = this.props;
                    if (setHeaderHeight)
                        setHeaderHeight(el.offsetHeight);
                });
            }
        }, 100);
    }
    headerColorChange() {
        const { classes, color, changeColorOnScroll } = this.props;
        if (this.state.scroll >= this.state.top) {
            document.body
                .getElementsByTagName("header")[0]
                .classList.remove(classes[color]);
            document.body
                .getElementsByTagName("header")[0]
                .classList.add(classes[changeColorOnScroll.color]);
        } else {
            document.body
                .getElementsByTagName("header")[0]
                .classList.add(classes[color]);
            document.body
                .getElementsByTagName("header")[0]
                .classList.remove(classes[changeColorOnScroll.color]);
        }
    }
    componentWillUnmount() {
        if (this.props.changeColorOnScroll) {
            window.removeEventListener("scroll", this.headerColorChange);
        }
        window.removeEventListener('scroll', this.handleScroll);
    }
    render() {
        const {
            classes,
            color,
            rightLinks,
            midLinks,
            leftLinks,
            brand,
            fixed,
            absolute,
            routes,
            triggerSearch,
            location,
            image,
            notHomePage,
            isFullScreen,
            loginPage,
            hideHeaderSearhBox,
            authenticated,
            cookies,
            ...others
        } = this.props;
        const searchPage = others.searchPage ? others.searchPage : false;
        const appBarClasses = classNames({
            [classes.appBar]: true,
            [classes.isFullScreen]: isFullScreen,
            [classes[color]]: color,
            [classes.topAppBar]: this.state.scroll >= this.state.top || notHomePage || loginPage,
        });
        const searchBar = classNames({
            [classes.searchBar]: true,
            [classes.searchResultBar]: searchPage,
            [classes.newsPageBar]: hideHeaderSearhBox,
        })
        const brandComponent = (
            !authenticated ?
                (
                    <Button
                        className={classes.title}
                        href={"/home"}
                        disableRipple
                    >
                        <img src={image} width={"288px"} alt="DIBots Logo" />
                        {/* <img src={image} width={"450px"} alt="Bursa DIBots Logo" /> */}
                    </Button>
                ) :

                <Button
                    className={classes.title}
                    href={"/dashboard"}
                    disableRipple
                >
                    <img src={image} width={"288px"} alt="DIBots Logo" />
                    {/* <img src={image} width={"450px"} alt="Bursa DIBots Logo" /> */}
                </Button>

        );
        return (
            <AppBar className={appBarClasses}>
                <Toolbar className={classes.container}>
                    {leftLinks !== undefined ? brandComponent : null}
                    <div className={classes.flex}>
                        {leftLinks !== undefined ? (
                            <Hidden smDown implementation="css">
                                {leftLinks}
                            </Hidden>
                        ) : (
                            brandComponent
                        )}
                    </div>
                    <div className={searchBar}>
                        {!loginPage &&
                            ((authenticated && this.state.scroll >= this.state.top) ||
                                (notHomePage && !searchPage)) ?
                            <SearchBox {...others}
                                authenticated={authenticated}
                                location hidden search={true} />
                            :
                            // <List className={classes.list}>
                            //     <ListItem className={classes.listItem}>
                            //         <Button
                            //             href="/loginPage"
                            //             color="transparent"
                            //             className={classes.navLink}
                            //         >
                            //             Service
                            //         </Button>
                            //     </ListItem>
                            //     <ListItem className={classes.listItem}>
                            //         <Button
                            //             href="/contactus"
                            //             color="transparent"
                            //             className={classes.navLink}
                            //         >
                            //             Contact Us
                            //         </Button>
                            //     </ListItem>
                            //     <ListItem className={classes.listItem}>
                            //         <Button
                            //             href="/aboutus"
                            //             color="transparent"
                            //             className={classes.navLink}
                            //         >
                            //             About
                            //         </Button>
                            //     </ListItem>
                            //     <ListItem className={classes.listItem}>
                            //         <Button
                            //             href={"/home"}
                            //             color="transparent"
                            //             className={classes.navLink}
                            //         >
                            //             Home
                            //         </Button>
                            //     </ListItem>
                            // </List>
                            ""
                        }
                        {/* {!loginPage && ((authenticated && this.state.scroll >= 200) || (notHomePage && !searchPage)) ?
                            <SearchBox {...others} authenticated={authenticated} location hidden search={true} themeColor={cookies.get('themeColor')} /> : ""} */}

                    </div>
                    <div className={classes.flex}>
                        <Hidden smDown implementation="css">
                            <div>{midLinks}</div>
                        </Hidden>
                    </div>
                </Toolbar>
                <Hidden lgUp implementation="css">
                    <Menu
                        id="customized-menu"
                        anchor={"right"}
                        settingOpen={this.state.settingOpen}
                        keepMounted
                        open={this.state.settingOpen}
                        onClose={this.handleSettingMenu}
                    >
                        <MenuItem>
                            <ListItemIcon>
                                <SendIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Sent mail" />
                        </MenuItem>
                    </Menu>
                </Hidden>
                {/* <Hidden lgUp implementation="css">
                    <Drawer
                        variant="temporary"
                        anchor={"right"}
                        open={this.state.mobileOpen}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        onClose={this.handleDrawerToggle}
                    >
                        <div className={classes.appResponsive}>
                            {leftLinks}
                            {
                                !loginPage && authenticated && (this.state.scroll >= this.state.top || (notHomePage && !others.searchPage)) ?
                                    <SearchBox {...others} authenticated={authenticated} small search={true} />
                                    : ""
                            }
                            {
                                !loginPage && authenticated && (this.state.scroll >= this.state.top || (notHomePage && !others.searchPage)) ?
                                    <SearchBox {...others} authenticated={authenticated} small search={true} themeColor={cookies.get('themeColor')} />
                                    : ""
                            }
                            <div className={classes.smallLinks}>
                                <div className={classes.hideLinks}>
                                    {midLinks}
                                </div>
                                {rightLinks}
                            </div>
                        </div>
                    </Drawer>
                </Hidden> */}
            </AppBar>
        );
    }
}

Header.defaultProp = {
    color: "white"
};

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "transparent",
        "white",
        "rose",
        "dark",
        "blue"
    ]),
    rightLinks: PropTypes.node,
    leftLinks: PropTypes.node,
    brand: PropTypes.string,
    fixed: PropTypes.bool,
    absolute: PropTypes.bool,
    // this will cause the sidebar to change the color from
    // this.props.color (see above) to changeColorOnScroll.color
    // when the window.pageYOffset is heigher or equal to
    // changeColorOnScroll.height and then when it is smaller than
    // changeColorOnScroll.height change it back to
    // this.props.color (see above)
    changeColorOnScroll: PropTypes.shape({
        height: PropTypes.number.isRequired,
        color: PropTypes.oneOf([
            "primary",
            "info",
            "success",
            "warning",
            "danger",
            "transparent",
            "white",
            "rose",
            "dark"
        ]).isRequired
    })
};

export default withStyles(headerStyle)(Header);
